import React from 'react';
import { Announcement } from '../Presentation/Announcement';

type Props = {
  unreadCount: number;
  markArticlesAsRead: () => void;
};

export const AnnouncementContainer: React.FC<Props> = ({
  unreadCount,
  markArticlesAsRead,
}) => {
  return (
    <Announcement
      unreadCount={unreadCount}
      markArticlesAsRead={markArticlesAsRead}
    />
  );
};
